import { Injectable, Injector } from '@angular/core';
import { EmployerContribution } from '../entities/employerContribution';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class EmployerContributionService extends BaseCrudService<EmployerContribution> {

  public uri = '/api/employerContribution/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployerContributionService');
  }

  buildSentence(entity?: EmployerContribution, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.sequence ? 'sequence'
          + QueryOperator.Equal + entity.sequence
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          'fiscalYear.id' + QueryOperator.Equal + entity.fiscalYear.id + QueryOperator.Split
        );
      }
      if (entity.mcppConcept && entity.mcppConcept.id) {
        query = query.concat(
          'mcppConcept.id' + QueryOperator.Equal + entity.mcppConcept.id + QueryOperator.Split
        );
      }
      if (entity.plameConcept && entity.plameConcept.id) {
        query = query.concat(
          'plameConcept.id' + QueryOperator.Equal + entity.plameConcept.id + QueryOperator.Split
        );
      }
      if (entity.expenseNature && entity.expenseNature.id) {
        query = query.concat(
          'expenseNature.id' + QueryOperator.Equal + entity.expenseNature.id + QueryOperator.Split
        );
      } 
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  // getSequenceCode(): Observable<string> {
  //     const url = this.rutaServidor + this.uri + 'maxCode/';
  //     return this.httpClient.get<any>(url)
  //         .pipe(
  //             map(response => {
  //                 // debugger;
  //                 const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 2);
  //                 const sequence = (parseInt(code, 10)) + 1;
  //                 return FormatUtils.padLeftZero(sequence, 2);
  //             }),
  //             tap(response =>  {
  //                //console.log(response);
  //             })
  //         );
  // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/employer-contribution.service.ts